import { render, staticRenderFns } from "./MessageFile.vue?vue&type=template&id=2e004e58&scoped=true"
import script from "./MessageFile.vue?vue&type=script&lang=js"
export * from "./MessageFile.vue?vue&type=script&lang=js"
import style0 from "./MessageFile.vue?vue&type=style&index=0&id=2e004e58&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e004e58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e004e58')) {
      api.createRecord('2e004e58', component.options)
    } else {
      api.reload('2e004e58', component.options)
    }
    module.hot.accept("./MessageFile.vue?vue&type=template&id=2e004e58&scoped=true", function () {
      api.rerender('2e004e58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Chat/Message/MessageFile.vue"
export default component.exports